(function (root) {
  // Das Laufband vervielfacht seine Spur wie live und schiebt sie um genau eine Kopie, damit der Sprung zurück unsichtbar bleibt.
  var doc = root.document;
  if (!doc || !root.customElements || !root.HTMLElement) return;

  var REDUCED = '(prefers-reduced-motion: reduce)';
  var MAX_COPIES = 24;

  var Element = class extends root.HTMLElement {
    connectedCallback() {
      if (this.track) return;
      var track = this.querySelector('[data-run-track]');
      if (!track || !track.children.length) return;
      if (root.matchMedia && root.matchMedia(REDUCED).matches) return;
      var copies = parseInt(this.getAttribute('data-copies'), 10);
      if (!(copies >= 2)) return;
      copies = Math.min(copies, MAX_COPIES);
      var originals = Array.prototype.slice.call(track.children);
      for (var i = 1; i < copies; i += 1) {
        originals.forEach(function (child) {
          var copy = child.cloneNode(true);
          // Eine Kopie ist Schmuck: nicht vorgelesen, nicht fokussierbar, keine Id doppelt.
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('inert', '');
          copy.removeAttribute('id');
          Array.prototype.forEach.call(copy.querySelectorAll('[id]'), function (node) {
            node.removeAttribute('id');
          });
          track.appendChild(copy);
        });
      }
      this.track = track;
      this.copies = copies;
      this.onResize = this.measure.bind(this);
      root.addEventListener('resize', this.onResize);
      this.measure();
      this.setAttribute('data-running', '');
    }

    disconnectedCallback() {
      if (this.onResize) root.removeEventListener('resize', this.onResize);
    }

    measure() {
      if (!this.track) return;
      var shift = this.track.scrollWidth / this.copies;
      if (!(shift > 0)) return;
      this.style.setProperty('--run-shift', shift + 'px');
      var speed = parseFloat(this.getAttribute('data-pixels-per-second'));
      if (speed > 0) this.style.setProperty('--run-duration', shift / speed + 's');
    }
  };

  if (!root.customElements.get('running-row')) root.customElements.define('running-row', Element);
})(window);
